import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { cartContext } from "./../../Context/CartContext";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import $ from "jquery";

export default function ProductDetails({ userData }) {
  const navigate = useNavigate();
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  const { add, remove, update, cartData } = useContext(cartContext);
  const [productDet, setproductDet] = useState([]);
  const [cartProducts, setcartProducts] = useState(null);
  let details = productDet[productDet.length - 1];

  let allCartID = cartData?.data?.products?.map((e) => e.product._id);

  const [productDetails, setproductDetails] = useState(null);
  let { id } = useParams();

  async function getProductDetails(id) {
    let { data } = await axios.get(`${baseURL}/api/v1/products/${id}`);
    setproductDetails(data.data);
  }

  let images = [];
  images = productDetails?.images?.map((e) => ({
    original: `${e}`,
    thumbnail: `${e}`,
  }));

  async function addProduct(id) {
    if (userData === null) {
      navigate("/login");
    } else {
      let response = await add(id);
      if (response !== false) {
        setproductDet(response?.data?.products);
        let idResponse = response.data.products.map((e) => e.product);
        setcartProducts(idResponse);
        $(".addBtn").fadeOut(200, () => {
          $(".successMsg").fadeIn(200, () => {
            setTimeout(() => {
              $(".successMsg").fadeOut(200, () => {
                $(".removing").fadeIn(200);
              });
            }, 2000);
          });
        });
      }
    }
  }

  async function updateCount(id, count) {
    let response = await update(id, count);
    if (response !== false) {
      setproductDet(response?.data?.products);
      $(".updateMsg").fadeIn(200, () => {
        setTimeout(() => {
          $(".updateMsg").fadeOut(200);
        }, 2000);
      });
    }
  }

  async function removeProduct(id) {
    let response = await remove(id);
    if (response !== false) {
      setproductDet(response?.data?.products);
      $(".removing").fadeOut(200, () => {
        $(".deleteMsg").fadeIn(200, () => {
          setTimeout(() => {
            $(".deleteMsg").fadeOut(200, () => {
              $(".addBtn").fadeIn(200);
            });
          }, 2000);
        });
      });
    }
  }

  function checkProductStatus() {
    if (allCartID?.includes(id)) {
      $(".addBtn").fadeOut(
        100,
        () => {
          $(".removing").fadeIn(100);
        },
        100
      );
    }
  }
  console.log(allCartID);
  console.log(id);

  useEffect(() => {
    getProductDetails(id);
  }, []);

  return (
    <>
      {productDetails ? (
        <div className="row align-items-center py-5 ">
          <div className="col-md-4">
            <ImageGallery
              items={images}
              slideInterval={2000}
              slideOnThumbnailOver={true}
              showIndex={true}
              autoPlay={true}
            />
          </div>
          <div className="col-md-8">
            <h2>{productDetails?.title}</h2>

            <p className="text-muted p-3 mb-0">{productDetails?.description}</p>
            <hr className="my-0 mb-3" />
            <h2 className="text-main fw-bold h5  mt-2">
              Brand:{" "}
              <span className="text-dark fw-normal">
                <Link
                  className="hoveringClick"
                  to={`/branddetails/${productDetails?.brand?._id}`}
                >
                  {productDetails?.brand?.name}
                </Link>
              </span>{" "}
              /{" "}
              <span className="text-dark fw-normal normal">
                {productDetails?.subcategory[0].name}
              </span>
            </h2>
            <h2 className="text-main fw-bold h5">
              In Stock:{" "}
              <span className="text-dark fw-normal">
                {productDetails?.quantity}
              </span>
            </h2>
            <div className="d-flex justify-content-between mb-1">
              <p>
                {productDetails?.priceAfterDiscount ? (
                  <>
                    <span className=" text-decoration-line-through text-muted moderate">
                      {productDetails?.price}
                    </span>{" "}
                    <span className="fw-bold">
                      {productDetails?.priceAfterDiscount}EGP{" "}
                      <span
                        style={{
                          "--fa-animation-duration": "2s",
                          "--fa-fade-opacity": 0.6,
                        }}
                        className="ms-2 d-inline-block p-1 bg-danger text-white rounded-2 fa-fade"
                      >
                        On Sale
                      </span>
                    </span>
                  </>
                ) : (
                  <span className="fw-bold">{productDetails?.price}EGP</span>
                )}
              </p>
              <p>
                <span className="fw-bold text-muted d-flex">
                  {productDetails?.ratingsAverage}{" "}
                  <Stack spacing={1}>
                    <Rating
                      name="half-rating-read"
                      defaultValue={productDetails?.ratingsAverage}
                      precision={0.1}
                      readOnly
                    />
                  </Stack>{" "}
                </span>
              </p>
            </div>

            <button
              onClick={() => addProduct(id)}
              className="btn Btn w-100 addBtn"
            >
              Add to Cart <i className="ms-2 fs-5 fa-solid fa-cart-plus"></i>
            </button>

            <div
              className="alert alert-success successMsg"
              style={{ display: "none" }}
            >
              Product added successfully to your cart{" "}
              <i className="me-2 fs-5 fa-regular fa-thumbs-up"></i>
            </div>
            <div
              className="alert alert-danger deleteMsg"
              style={{ display: "none" }}
            >
              Product Removed successfully to your cart
            </div>

            <div className="removing" style={{ display: "none" }}>
              <div className="d-flex align-items-center justify-content-center">
                <button
                  onClick={() => updateCount(id, details?.count - 1)}
                  className="btn Btn"
                >
                  <i className="fa-solid fa-minus"></i>
                </button>
                <span className="text-main mx-3">
                  {" "}
                  {details?.count} in your cart
                </span>
                <button
                  onClick={() => updateCount(id, details?.count + 1)}
                  className="btn Btn"
                >
                  <i className="fa-solid fa-plus"></i>
                </button>
              </div>
              <div
                className="alert alert-success updateMsg mt-2"
                style={{ display: "none" }}
              >
                Product Quantity updated successfully
                <i className="ms-2 fs-5 fa-regular fa-thumbs-up"></i>
              </div>
              <button
                onClick={() => removeProduct(id)}
                className="btn btn-outline-danger  w-100 mt-2"
              >
                Remove from Cart{" "}
                <i className="ms-2 fs-5 fa-regular fa-trash-can"></i>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
}
